export default "__VITE_ASSET__CSzJefFn__"